import React, { Component } from 'react';
import * as Tone from 'tone';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import 'bootstrap/dist/css/bootstrap.min.css';


class ToneJSLoopPlayer extends Component {
    constructor(props) {
        super(props);
        this.player = null;

        this.state = {
            isPlaying: false,
            speed: 1.0 // Начальная скорость
        };
    }

    componentDidMount() {
        // Создаем гранулярный плеер, который сохраняет питч при изменении скорости
        this.player = new Tone.GrainPlayer({
            url: this.props.elementData.file,
            loop: true,
            onload: () => console.log("Аудио успешно загружено в буфер!")
        }).toDestination(); // Подключаем к выходу звука
    }

    componentWillUnmount() {
        if (this.player) this.player.dispose();
    }

    togglePlay = async () => {
        // В Web Audio API контекст должен запускаться по клику пользователя
        await Tone.start();

        if (this.state.isPlaying) {
            this.player.stop();
        } else {
            this.player.start();
        }
        this.setState({ isPlaying: !this.state.isPlaying });
    };

    // Метод обрабатывает движение ползунка
    handleSpeedChange = (event) => {
        const newSpeed = parseFloat(event.target.value);
        this.setState({ speed: newSpeed });

        if (this.player) {
            // Изменяем скорость на лету
            this.player.playbackRate = newSpeed;
        }
    };

    render() {
        return (
            <Accordion.Item eventKey={this.props.elementData.id} >
                <Accordion.Header>{this.props.elementData.name}</Accordion.Header>
                <Accordion.Body>
                    <div className="d-grid gap-2">
                      <Button variant="primary" size="lg" onClick={this.togglePlay}>{this.state.isPlaying ? 'Stop' : 'Start'}</Button>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <label htmlFor="speed-slider">
                            bpm: <strong>{(this.state.speed.toFixed(2) * this.props.elementData.bpm).toFixed(0)}</strong>
                        </label>
                        <input
                            id="speed-slider"
                            type="range"
                            min="0.9"
                            max="1.2"
                            step="0.01" // Шаг изменения для максимальной плавности
                            value={this.state.speed}
                            onChange={this.handleSpeedChange}
                        />
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        );
    }
}

export default ToneJSLoopPlayer;